<script setup lang="ts">
definePageMeta({ layout: false, colorMode: 'light' })

const route = useRoute()
const tenantSlug = String(route.params.tenantSlug)
const api = usePortalAccountApi(tenantSlug)

const email = ref('')
const loading = ref(false)
const done = ref(false)

async function submit() {
  loading.value = true
  try {
    await api.forgotPassword(email.value)
  } finally {
    // Always show the same generic confirmation — the backend is
    // deliberately silent on whether the email exists.
    done.value = true
    loading.value = false
  }
}
</script>

<template>
  <div class="min-h-screen bg-gray-50 flex items-center justify-center p-6">
    <div class="w-full max-w-sm space-y-6">
      <h1 class="text-xl font-semibold text-center">
        Reset your password
      </h1>

      <p
        v-if="done"
        class="text-sm text-green-700 bg-green-50 border border-green-200 rounded p-3 text-center"
      >
        If that email is registered, a reset link is on its way.
      </p>

      <form
        v-else
        class="space-y-4"
        @submit.prevent="submit"
      >
        <div>
          <label class="block text-sm text-gray-700 mb-1">Email</label>
          <input
            v-model="email"
            type="email"
            required
            class="w-full border rounded px-3 py-2 text-sm"
          >
        </div>
        <button
          type="submit"
          :disabled="loading"
          class="w-full bg-black text-white rounded py-2 text-sm disabled:opacity-50"
        >
          {{ loading ? 'Sending…' : 'Send reset link' }}
        </button>
      </form>

      <p class="text-xs text-gray-500 text-center">
        <NuxtLink
          :to="`/client/${tenantSlug}/login`"
          class="text-blue-600 hover:underline"
        >
          Back to sign in
        </NuxtLink>
      </p>
    </div>
  </div>
</template>
